import React from 'react'

import Link from '../Link'

const By1stLogFooter = (): React.ReactElement => {
  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        paddingLeft: 10,
        paddingBottom: 5,
      }}
    >
      <a
        href="https://www.1st-log.com/"
        style={{ textDecoration: 'none', fontWeight: 'bold' }}
        className="text-muted"
        target="_blank"
        rel="noreferrer"
      >
        powered by 1st Log
      </a>
    </div>
  )
}

export default By1stLogFooter
